import css from './index.module.scss';
import { getLang } from 'lowcomp/plugins/member/utils';
import { i18n } from '../i18n';
import { useRouter } from 'next/router';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import Point from '../icons/Point';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';

export default function Cards({ campaignId, cards, isOpenMore, segment, isLogin, isEditStatus, showCartIcon, handleToggleMore, handleAddCart, ...rest }: any) {
    const { locale = 'us' } = useRouter();
    const t = getLang(i18n, locale);
    const ALIGN_CENTER = [1, 2, 4].includes(cards?.length);
    const PAD_CENTER = cards?.length === 1;
    // console.log('segment', segment);
    // console.log('cards', cards);
    const {
        eventTheme,
        cardBgColor,
        cardTitleColor,
        cardSubtitleColor,
        cardSoldColor,
        cardStockColor,
        cardLeftBgColor,
        cardLeftTextColor,
        cardDiscountPriceColor,
        cardOriginalPriceColor,
        cardMemberPriceColor,
        cardDiscountTagTextColor,
        cardDiscountTagBgColor,
        cardPointTagTextColor,
        cardPointTagBgColor,
        cardMemberTagTextColor,
        cardMemberTagBgColor,
        cardMoreTextColor,
        cardMoreBtnColor,
        cardBuyTextColor,
        cardBuyBtnColor,
        cardCartTextColor,
        cardCartBtnColor,
    } = { ...rest };

    return (
        <div className={`flash-sale-cards ${css['flash-sale-cards']}`}>
            <ul className={`cards ${ALIGN_CENTER ? 'pc-center' : ''} ${PAD_CENTER ? 'pad-center' : ''}`}>
                {cards?.map((card: any, k: number) => (
                    <li className={`card`} key={k} style={{ backgroundColor: cardBgColor }}>
                        {/* 折扣角标 + 积分角标 */}
                        {[1, 2, 3].includes(card?.tagPosition) &&
                            !(segment?.hidePrice?.includes('1') && !isLogin) &&
                            !(segment?.hidePrice?.includes('2') && isLogin) && (
                                <div className={`card-tags${card?.tagPosition === 2 ? ' reverse' : ''}`}>
                                    {/* 折扣角标 */}
                                    {[1, 2, 3].includes(card?.discountTagType) && (
                                        <span className="tag-off" style={{ color: cardDiscountTagTextColor, backgroundColor: cardDiscountTagBgColor }}>
                                            {card?.discountTagType === 1 && (
                                                <>
                                                    {FormatMoneyLocal((card?.compareAtPrice ?? card?.price) - (card?.memberPrice ?? card?.price), locale) +
                                                        t('card_tag_off')}
                                                </>
                                            )}
                                            {card?.discountTagType === 2 && (
                                                <>
                                                    {card?.countRetention === 1 && (
                                                        <>
                                                            {Math.round(
                                                                100 * (1 - (card?.memberPrice ?? card?.price) / (card?.compareAtPrice ?? card?.price)),
                                                            ) +
                                                                '%' +
                                                                t('card_tag_off')}
                                                        </>
                                                    )}
                                                    {card?.countRetention === 2 && (
                                                        <>
                                                            {Math.floor(
                                                                100 * (1 - (card?.memberPrice ?? card?.price) / (card?.compareAtPrice ?? card?.price)),
                                                            ) +
                                                                '%' +
                                                                t('card_tag_off')}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            {card?.discountTagType === 3 && <>{card?.discountTagText}</>}
                                        </span>
                                    )}
                                    {/* 积分角标 */}
                                    {[1, 2].includes(card?.pointTagType) && [1, 2].includes(card?.tagPosition) && (
                                        <div className="tag-point">
                                            {card?.pointTagType === 1 && card?.pointTagTimes && card?.pointTagRate && (
                                                <div className="point-box">
                                                    <Point />
                                                    <span className="times" style={{ color: cardPointTagTextColor }}>
                                                        {card?.pointTagTimes}
                                                        {t('card_tag_times')}
                                                    </span>
                                                    <span className="point" style={{ backgroundColor: cardPointTagBgColor, color: cardPointTagTextColor }}>
                                                        {card?.countRetention === 1
                                                            ? Math.round(
                                                                  (card?.pointTagRate / 100) *
                                                                      card?.pointTagTimes *
                                                                      (card?.pointTagType === 1
                                                                          ? card?.memberPrice ?? card?.price
                                                                          : card?.pointTagType === 2
                                                                          ? card?.price
                                                                          : card?.compareAtPrice ?? card?.price),
                                                              )
                                                            : Math.floor(
                                                                  (card?.pointTagRate / 100) *
                                                                      card?.pointTagTimes *
                                                                      (card?.pointTagType === 1
                                                                          ? card?.memberPrice ?? card?.price
                                                                          : card?.pointTagType === 2
                                                                          ? card?.price
                                                                          : card?.compareAtPrice ?? card?.price),
                                                              )}
                                                        {t('card_tag_point')}
                                                    </span>
                                                </div>
                                            )}
                                            {card?.pointTagType === 2 && card?.pointTagText && (
                                                <p
                                                    className="point-text"
                                                    style={{
                                                        color: cardPointTagTextColor,
                                                        borderColor: cardPointTagTextColor,
                                                        backgroundColor: cardPointTagBgColor,
                                                    }}
                                                >
                                                    {card?.pointTagText}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        <div className="card-info">
                            <div className="card-top">
                                {card?.imgUrl && (
                                    <div className="card-img">
                                        <EfImg pc={card?.imgUrl} />
                                        {segment?.segment === 2 && segment?.inventoryStyle === 2 && typeof card?.inventoryQuantity === 'number' && (
                                            <span className="card-left" style={{ backgroundColor: cardLeftBgColor, color: cardLeftTextColor }}>
                                                {t.rich('card_inventory_left', {
                                                    num: card?.inventoryQuantity,
                                                })}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {/* 积分角标 */}
                                {[1, 2].includes(card?.pointTagType) &&
                                    card?.tagPosition === 3 &&
                                    !(segment?.hidePrice?.includes('1') && !isLogin) &&
                                    !(segment?.hidePrice?.includes('2') && isLogin) && (
                                        <div className="card-point">
                                            {card?.pointTagType === 1 && card?.pointTagTimes && card?.pointTagRate && (
                                                <div className="point-box">
                                                    <Point />
                                                    <span className="times" style={{ color: cardPointTagTextColor }}>
                                                        {card?.pointTagTimes}
                                                        {t('card_tag_times')}
                                                    </span>
                                                    <span className="point" style={{ backgroundColor: cardPointTagBgColor, color: cardPointTagTextColor }}>
                                                        {card?.countRetention === 1
                                                            ? Math.round(
                                                                  (card?.pointTagRate / 100) *
                                                                      card?.pointTagTimes *
                                                                      (card?.pointTagType === 1
                                                                          ? card?.memberPrice ?? card?.price
                                                                          : card?.pointTagType === 2
                                                                          ? card?.price
                                                                          : card?.compareAtPrice ?? card?.price),
                                                              )
                                                            : Math.floor(
                                                                  (card?.pointTagRate / 100) *
                                                                      card?.pointTagTimes *
                                                                      (card?.pointTagType === 1
                                                                          ? card?.memberPrice ?? card?.price
                                                                          : card?.pointTagType === 2
                                                                          ? card?.price
                                                                          : card?.compareAtPrice ?? card?.price),
                                                              )}
                                                        {t('card_tag_point')}
                                                    </span>
                                                </div>
                                            )}
                                            {card?.pointTagType === 2 && card?.pointTagText && (
                                                <p
                                                    className="point-text"
                                                    style={{
                                                        color: cardPointTagTextColor,
                                                        borderColor: cardPointTagTextColor,
                                                        backgroundColor: cardPointTagBgColor,
                                                    }}
                                                >
                                                    {card?.pointTagText}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                {card?.title && (
                                    <p className="card-title" style={{ color: cardTitleColor }}>
                                        {card.title}
                                    </p>
                                )}
                                {card?.subtitle && (
                                    <p className="card-subtitle" style={{ color: cardSubtitleColor }}>
                                        {card.subtitle}
                                    </p>
                                )}
                                {card?.desc && (
                                    <p className="card-desc" style={{ color: cardSubtitleColor }}>
                                        {card.desc}
                                    </p>
                                )}
                            </div>
                            <div className="card-bot">
                                {/* 价格 */}
                                <div className="card-price">
                                    <span className="member-price" style={{ color: cardMemberPriceColor }}>
                                        {(segment?.hidePrice?.includes('1') && !isLogin) || (segment?.hidePrice?.includes('2') && isLogin)
                                            ? new Array(card?.priceLength || 1).fill('?').join('')
                                            : card?.memberPrice >= 0
                                            ? FormatMoneyLocal(card?.memberPrice, locale)
                                            : ''}
                                        {!((segment?.hidePrice?.includes('1') && !isLogin) || (segment?.hidePrice?.includes('2') && isLogin)) && (
                                            <span className="suffix">{t('card_price_tax')}</span>
                                        )}
                                    </span>
                                    {card?.memberTagText && (
                                        <>
                                            <span
                                                className="member-tag"
                                                style={{
                                                    backgroundColor: cardMemberTagTextColor,
                                                }}
                                            >
                                                <span
                                                    className="member-tag-text"
                                                    style={{
                                                        color: cardMemberTagTextColor,
                                                        backgroundColor: cardMemberTagBgColor,
                                                    }}
                                                >
                                                    {card.memberTagText}
                                                </span>
                                            </span>
                                            <p className="member-gap"></p>
                                        </>
                                    )}
                                    {(card?.price || card?.price === 0) && card?.price !== card?.memberPrice && (
                                        <span
                                            className="discount-price"
                                            style={{
                                                color: cardDiscountPriceColor,
                                                textDecoration: card?.price === card?.compareAtPrice || !card?.compareAtPrice ? 'line-through' : '',
                                            }}
                                        >
                                            {FormatMoneyLocal(card.price, locale)}
                                            {/* <span className="suffix s">{t('card_price_tax')}</span> */}
                                            {card?.price !== card?.compareAtPrice && card?.price !== card?.memberPrice && card?.compareAtPrice
                                                ? `(${t('card_non_member_price')})`
                                                : ''}
                                        </span>
                                    )}
                                    {(card?.compareAtPrice || card?.compareAtPrice === 0) &&
                                        card?.compareAtPrice !== card?.memberPrice &&
                                        card?.compareAtPrice !== card?.price && (
                                            <span className="original-price" style={{ color: cardOriginalPriceColor }}>
                                                {FormatMoneyLocal(card.compareAtPrice, locale)}
                                                {/* <span className="suffix s">{t('card_price_tax')}</span> */}
                                            </span>
                                        )}
                                </div>
                                {/* 进度条 */}
                                {segment?.segment === 2 &&
                                    segment?.inventoryStyle === 1 &&
                                    typeof card?.totalInventoryQuantity === 'number' &&
                                    typeof card?.inventoryQuantity === 'number' && (
                                        <div className="card-progress">
                                            <div className="bar">
                                                <p
                                                    className="inner-bar"
                                                    style={{
                                                        width:
                                                            ((card?.totalInventoryQuantity - card?.inventoryQuantity) / card?.totalInventoryQuantity || 0) *
                                                                100 +
                                                            '%',
                                                        backgroundColor: eventTheme,
                                                    }}
                                                ></p>
                                            </div>
                                            <div className="bar-text">
                                                <span className="sold" style={{ color: cardSoldColor }}>
                                                    {t('card_sold')}
                                                    {card.totalInventoryQuantity - card.inventoryQuantity}
                                                </span>
                                                <span className="stock" style={{ color: cardStockColor }}>
                                                    {t('card_stock')}
                                                    {card.inventoryQuantity}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>
                        {/* 按钮 */}
                        {((card?.prevBtns?.length > 0 && segment?.segment === 1) || (card?.currentBtns?.length > 0 && [2, 3].includes(segment?.segment))) &&
                            isLogin && (
                                <div className="card-btns">
                                    {((segment?.segment === 1 && card?.prevBtns?.includes('2')) ||
                                        ([2, 3].includes(segment?.segment) && card?.currentBtns?.includes('2'))) &&
                                        card?.productUrl && (
                                            <>
                                                {segment?.segment === 3 ? (
                                                    <button disabled className="card-btn btn-disable">
                                                        {t('card_btn_learn_more')}
                                                    </button>
                                                ) : (
                                                    <EfLink
                                                        className="card-btn btn-more"
                                                        href={card?.productUrl}
                                                        dataLayer={{
                                                            event: 'uaEvent',
                                                            event_name: 'buy',
                                                            product_name: card?.title,
                                                            position: 'Flash Sale_Lean More',
                                                        }}
                                                        style={{
                                                            color: cardMoreTextColor,
                                                            backgroundColor: cardMoreBtnColor,
                                                            borderColor: cardMoreBtnColor,
                                                        }}
                                                    >
                                                        {t('card_btn_learn_more')}
                                                    </EfLink>
                                                )}
                                            </>
                                        )}
                                    {segment.segment === 1 && card?.prevBtns?.includes('1') && (
                                        <button className="card-btn btn-disable">{t('card_btn_coming_soon')}</button>
                                    )}
                                    {((typeof card?.inventoryQuantity === 'number' && card?.inventoryQuantity > 0) ||
                                        card?.inventoryQuantity === '不限制库存' ||
                                        (!card?.inventoryQuantity && card?.inventoryQuantity !== 0)) && (
                                        <>
                                            {((segment.segment === 2 && (card?.checkoutUrl || card?.variantId)) ||
                                                (segment.segment === 3 && segment?.processMethod === 2)) &&
                                                card?.currentBtns?.includes('3') && (
                                                    <>
                                                        {segment?.segment === 3 ? (
                                                            <button disabled className="card-btn btn-disable">
                                                                {t('card_btn_buy_now')}
                                                            </button>
                                                        ) : (
                                                            <EfLink
                                                                className="card-btn btn-buy"
                                                                href={
                                                                    card?.checkoutUrl ||
                                                                    `https://${String(locale).toLowerCase()}.ecoflow.com/cart/${
                                                                        card?.variantId
                                                                    }:1?channel=buy_button`
                                                                }
                                                                target={'_blank'}
                                                                dataLayer={{
                                                                    event: 'uaEvent',
                                                                    event_name: 'checkout',
                                                                    button_name: `${t('card_btn_buy_now')}_${card?.title}`,
                                                                }}
                                                                style={{
                                                                    color: cardBuyTextColor,
                                                                    backgroundColor: cardBuyBtnColor,
                                                                    borderColor: cardBuyBtnColor,
                                                                }}
                                                            >
                                                                {t('card_btn_buy_now')}
                                                            </EfLink>
                                                        )}
                                                    </>
                                                )}
                                            {((segment.segment === 2 && card?.variantId) || (segment.segment === 3 && segment?.processMethod === 2)) &&
                                                card?.currentBtns?.includes('4') && (
                                                    <>
                                                        {segment?.segment === 3 ? (
                                                            <button disabled className="card-btn btn-disable">
                                                                {t('card_btn_add_cart')}
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className="card-btn btn-cart"
                                                                style={{
                                                                    color: cardCartTextColor,
                                                                    backgroundColor: cardCartBtnColor,
                                                                    borderColor: cardCartBtnColor,
                                                                }}
                                                                onClick={() => handleAddCart(card)}
                                                            >
                                                                {t('card_btn_add_cart')}
                                                            </button>
                                                        )}
                                                    </>
                                                )}
                                        </>
                                    )}
                                    {[2, 3].includes(segment.segment) &&
                                        (card?.currentBtns?.includes('3') || card?.currentBtns?.includes('4')) &&
                                        typeof card?.inventoryQuantity === 'number' &&
                                        card?.inventoryQuantity <= 0 && (
                                            <button disabled className="card-btn btn-disable">
                                                {t('card_btn_sold_out')}
                                            </button>
                                        )}
                                </div>
                            )}
                    </li>
                ))}
            </ul>
            {/* 超过6个时view more/view less 折叠/展开 按钮 */}
            {!isEditStatus && cards?.length > 6 && (
                <button className="view-more" onClick={handleToggleMore}>
                    <span className="view-text">{isOpenMore ? t('view_less') : t('view_more')}</span>
                    <svg
                        className={`arrow-icon ${isOpenMore ? 'reverse' : ''}`}
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_2667_51640)">
                            <path d="M12 7.39893L8 11.3989L4 7.39893" stroke="#3F68E0" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2667_51640">
                                <rect width="16" height="16" fill="white" transform="translate(0 0.732422)" />
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            )}
        </div>
    );
}
